import * as HLF from "html-living-framework";

export enum Direction {
    EAST,
    NORTH,
    WEST,
    SOUTH,
    NUM_ELEMENTS,
}

export const GRID_SIZE: PIXI.Point = new PIXI.Point(5, 5);
export const TILE_WIDTH: number = 121;
export const COLOUR_RAMP_COUNT: number = 25;

export const DIR_OFFSET: PIXI.Point[] = [
    new PIXI.Point(1, 0), // EAST
    new PIXI.Point(0, -1), // NORTH
    new PIXI.Point(-1, 0), // WEST
    new PIXI.Point(0, 1), // SOUTH
];
export const DIR_ORIGIN: PIXI.Point[] = [
    new PIXI.Point(1, 0.5), // EAST
    new PIXI.Point(0.5, 0), // NORTH
    new PIXI.Point(0, 0.5), // WEST
    new PIXI.Point(0.5, 1), // SOUTH
];

export function gridToLocal(pGridPos: PIXI.Point): PIXI.Point {
    const localPos: PIXI.Point = pGridPos.clone();
    // Offset so 0,0 is center
    HLF.PointUtils.subtractFromPoint(localPos, HLF.PointUtils.multiply(GRID_SIZE, 0.5));
    // Convert from grid coords to pixel coords
    return HLF.PointUtils.multiply(localPos, TILE_WIDTH);
}

export function localToGrid(pLocalPos: PIXI.Point): PIXI.Point {
    // Convert from pixel coords to grid coords
    const gridPos: PIXI.Point = HLF.PointUtils.multiply(pLocalPos, 1 / TILE_WIDTH);
    // Offset so 0,0 is top left
    HLF.PointUtils.addToPoint(gridPos, HLF.PointUtils.multiply(GRID_SIZE, 0.5));
    // Clamp coords to whole numbers
    gridPos.x = Math.floor(gridPos.x);
    gridPos.y = Math.floor(gridPos.y);
    return gridPos;
}
